<!--
  ~ Copyright (C) 2018 - present by OpenGamma Inc. and the OpenGamma group of companies
  ~
  ~ Please see distribution for license.
  -->
<og-details-list
  [title]="title"
  [loading]="loading"
  [list]="list"
  [showInputTemplate]="showInputTemplate"
  [theme]="theme"
  [size]="size"
  [canAddItems]="canAddItems"
  [canDeleteItems]="canDeleteItems"
  [itemTemplate]="itemTemplate"
  (listChange)="propagateListChange($event)"
  (addButtonClick)="showInputTemplate = true"
>
  <form class="form" input-template>
    <mat-form-field class="form__input" [color]="theme">
      <input
        matInput
        placeholder="Enter value here"
        name="newListEntry"
        [(ngModel)]="newListEntry"
      />
    </mat-form-field>

    <div class="form__buttons">
      <button mat-icon-button [color]="theme" (click)="showInputTemplate = false">
        <i class="material-icons">cancel</i>
      </button>
      <button mat-icon-button [color]="theme" (click)="triggerSave()">
        <i class="material-icons">save</i>
      </button>
    </div>
  </form>
</og-details-list>
